'use strict';

var _classCallCheck = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/createClass");

var assert = require('assert');

var withIs = require('class-is');

var CID = require('cids');

var DAGNode =
/*#__PURE__*/
function () {
  function DAGNode(data, links, serialized, multihash) {
    _classCallCheck(this, DAGNode);

    assert(serialized, 'DAGNode needs its serialized format');
    assert(multihash, 'DAGNode needs its multihash');
    this._cid = new CID(multihash);
    this._data = data || Buffer.alloc(0);
    this._links = links || [];
    this._serialized = serialized;
  }

  _createClass(DAGNode, [{
    key: "toJSON",
    value: function toJSON() {
      if (!this._json) {
        this._json = Object.freeze({
          data: this.data,
          links: this.links.map(function (l) {
            return l.toJSON();
          }),
          multihash: this._cid.toBaseEncodedString(),
          size: this.size
        });
      }

      return Object.assign({}, this._json);
    }
  }, {
    key: "toString",
    value: function toString() {
      return "DAGNode <".concat(this._cid.toBaseEncodedString(), " - data: \"").concat(this.data.toString(), "\", links: ").concat(this.links.length, ", size: ").concat(this.size, ">");
    }
  }, {
    key: "data",
    get: function get() {
      return this._data;
    },
    set: function set(data) {
      throw new Error("Can't set property: 'data' is immutable");
    }
  }, {
    key: "links",
    get: function get() {
      return this._links;
    },
    set: function set(links) {
      throw new Error("Can't set property: 'links' is immutable");
    }
  }, {
    key: "serialized",
    get: function get() {
      return this._serialized;
    },
    set: function set(serialized) {
      throw new Error("Can't set property: 'serialized' is immutable");
    }
  }, {
    key: "size",
    get: function get() {
      if (this._size === undefined) {
        this._size = this.links.reduce(function (sum, l) {
          return sum + l.size;
        }, this.serialized.length);
      }

      return this._size;
    },
    set: function set(size) {
      throw new Error("Can't set property: 'size' is immutable");
    }
  }, {
    key: "multihash",
    get: function get() {
      return this._cid.buffer;
    },
    set: function set(multihash) {
      throw new Error("Can't set property: 'multihash' is immutable");
    }
  }, {
    key: "cid",
    get: function get() {
      return this._cid;
    },
    set: function set(cid) {
      throw new Error("Can't set property: 'cid' is immutable");
    }
  }]);

  return DAGNode;
}();

exports = module.exports = withIs(DAGNode, {
  className: 'DAGNode',
  symbolName: '@ipld/js-ipld-dag-pb/dagnode'
});
exports.create = require('./create');
exports.clone = require('./clone');
exports.addLink = require('./addLink');
exports.rmLink = require('./rmLink');